<div fxLayout="column" fxLayoutAlign="space-between">
  <div fxFlex>
    <h3>Vote for "{{ dialogData.name }}"</h3>
    <p>You can add a comment about the things you are looking for (optional)</p>
  </div>

  <div fxLayout fxLayoutAlign="stretch center" fxLayoutGap="12px">
    <textarea matInput [style.height]="'156px'" [(ngModel)]="comment" placeholder="Add a comment"></textarea>
  </div>

  <div fxLayoutAlign="end center" fxLayoutGap="8px" style="margin-top: 40px">
    <button type="submit" mat-flat-button class="button__secondary" (click)="cancelUpvote()">Cancel</button>
    <button type="submit" mat-flat-button (click)="submitUpvote()">Vote</button>
  </div>
</div>
